const initEnd = new Date()
//Redux lopetuspäivämäärän hallinnalle
const endReducer = (state = initEnd, action) => {
  switch (action.type) {
  case 'SETEND':
    return action.end
  default:
    return state
  }
}

export const defineEnd = (end) => {
  return {
    type: 'SETEND',
    end
  }
}

export const setEnd = (end) => {
  return async (dispatch) => {
    dispatch(defineEnd(end))
  }
}

export default endReducer